import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

const PARAM = {
    OPEN: `is-open`,
    SCROLLTO: true,
    HEADER: 160
}

export default class extends module {
    constructor(m) {
        super(m);
    }

    setAttributes(el, attrs){
        for(var key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }

    init() {
        this.moduleId = this.el.getAttribute('data-mid');

        this.accordionItems = document.querySelectorAll('[data-mid="'+this.moduleId+'"] > [data-accordion="wrap"]');
        this.accordionTriggers = document.querySelectorAll('[data-mid="'+this.moduleId+'"] > [data-accordion="wrap"] > [data-accordion="trigger"]');
        this.accordionContents = document.querySelectorAll('[data-mid="'+this.moduleId+'"] > [data-accordion="wrap"] > [data-accordion="content"]');

        //console.log(this.accordionTriggers);

        if(this.accordionTriggers.length != this.accordionContents.length){
            throw new Error('Accordion : Number of triggers and contents does not match');
        }

        let i = 1;
        this.accordionTriggers.forEach(trigger => {
            this.setAttributes(trigger,{
                'id': this.moduleId+'-trigger-'+i,
                'aria-controls': this.moduleId+'-target-'+i,
                // 'aria-selected': "true",
                'aria-expanded': "false",
                'tabindex': '0'
            });

            trigger.addEventListener('click', (e) => {
                this.toggle(e);
            });

            i++;
        });

        let preOpenId = this.el.getAttribute('data-accordion-preopen');
        if(preOpenId && this.accordionContents[preOpenId]){
            let preOpenElement = this.accordionContents[preOpenId];
            preOpenElement.closest('[data-accordion="wrap"]').classList.add(PARAM.OPEN);
        }
    }

    /**
     * Toggle Action
     *
     * @param el {node}
     */
    toggle(el) {
        let target = el.currentTarget
        let parent = target.closest('[data-accordion="wrap"]')
        if (parent && parent.classList.contains(PARAM.OPEN)) {
            this.close()
        } else if (parent) {
            this.close()
            this.open(parent)
        } else {
            throw new Error('Invalid target')
        }
    }

    /**
     * Open Action
     *
     * @param el {node}
     */
    open(el) {
        el.classList.add(PARAM.OPEN);
        let curContent = el.querySelector('[data-accordion="content"]')
        let curTrigger = el.querySelector('[data-accordion="trigger"]')
        curTrigger.setAttribute('aria-expanded','true')

        if (PARAM.SCROLLTO) {
            setTimeout(function () {
                let newTop = window.pageYOffset + el.getBoundingClientRect().top - PARAM.HEADER;
                window.scrollTo({
                    top: newTop,
                    behavior: 'smooth'
                })
            }, 301)
        }
    }

    /**
     * Close Action
     *
     * @param
     */
    close() {
        this.accordionItems.forEach((item) => {
        let curTrigger = item.querySelector('[data-accordion="trigger"]')
        let curContent = item.querySelector('[data-accordion="content"]')
        item.classList.remove(PARAM.OPEN)
        curTrigger.setAttribute('aria-expanded','false');
        curContent.setAttribute('tabindex','-1');
    })
    }
}

/* 
// USAGE :
//  data-accordion-toggle = auto close already open accordion
//  data-accordion-scroll = Scroll to open accordion
//  data-accordion-preopen="0" = Pre Open accordion matching index

<div class="c-accordion" data-module="Accordion" data-accordion-toggle data-accordion-scroll data-accordion-preopen="0">
    <?php for($i=1; $i<=8; $i++): ?>
        <div class="c-accordion__section" data-accordion="wrap">
            <div class="c-accordion__header" data-accordion="trigger">
                <h3 class="c-accordion__header__title">
                    <?php $accordionTitle = "Titre de mon accordion - ".$i; ?>
                    <button class="c-accordion__button" aria-expanded="false" type="button" aria-label="Ouvrir <?=$accordionTitle; ?>">
                        <?=$accordionTitle; ?>
                    </button>
                </h3>
            </div>
            <div class="c-accordion__content" role="region" data-accordion="content">
                <div class="c-accordion__inner">
                    <article class="o-text">
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellat rem nisi soluta commodi harum deleniti, voluptatem itaque doloremque temporibus labore fugit iusto nesciunt esse rerum vitae, deserunt quidem aliquid error!</p>
                    </article>
                </div>
            </div>
        </div>
    <?php endfor; ?>
</div>
*/

/*
// Accordion with child, Just duplicate into the content the same markup as the parent

*/